module.exports = __webpack_public_path__ + "assets/img/tx113_3.ef036598.jpg";